/**
 * Email — enqueue a transactional email by writing to the `outbox`
 * collection in Firestore.
 *
 * A background Cloud Function (`processOutboxEmail`, see
 * functions/src/sendEmail.ts) listens for new `outbox` docs and sends
 * them via Brevo, then stamps `status` back onto the doc. The browser
 * never calls a function directly, so there's no public HTTPS endpoint —
 * which is what keeps this working under the org's Domain-Restricted-
 * Sharing policy (no `allUsers` invoker needed).
 */

import { addDoc, collection } from 'firebase/firestore';
import { firestore } from './firebase';

export interface SendEmailPayload {
  to: string;
  subject: string;
  textContent: string;
  htmlContent: string;
}

export async function sendTransactionalEmail(payload: SendEmailPayload) {
  if (!firestore) {
    throw new Error('Firestore is not initialized; cannot queue email.');
  }
  try {
    const ref = await addDoc(collection(firestore, 'outbox'), {
      ...payload,
      status: 'queued',
      createdAt: new Date().toISOString(),
    });
    return { queued: true, id: ref.id };
  } catch (error) {
    console.error('Failed to queue email:', error);
    throw error;
  }
}
